import { render, staticRenderFns } from "./bankSecurity.vue?vue&type=template&id=327bc0dd&scoped=true"
import script from "./bankSecurity.vue?vue&type=script&lang=js"
export * from "./bankSecurity.vue?vue&type=script&lang=js"
import style0 from "./bankSecurity.vue?vue&type=style&index=0&id=327bc0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bc0dd",
  null
  
)

export default component.exports